import { createContext } from 'react'
import { TypeCartePrepayee } from 'types/carteprepayee'

interface CartePrepayeeContextProps {
  carte: TypeCartePrepayee | null
  setCarte: (carte: TypeCartePrepayee | null) => void
}

export const CartePrepayeeContext = createContext<CartePrepayeeContextProps>({
  carte: null,
  setCarte: function defaultSetCarte() {
    // noop
  }
})
export default  CartePrepayeeContext
